// import '../streamcss/marquee.css';
import parse from 'html-react-parser';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';

import logger from '../../../../app/logger';
import { getCurrentConference } from '../../../../base/conference';
import { getParticipantCount } from '../../../../base/participants';
import { NOTIFICATION_TIMEOUT, showNotification } from '../../../../notifications';
import { DONATION_MAREQUE, FORMGUID } from '../../../actionTypes';
import {
    bindAmountSection,
    bindCampaignRaisedDetails,
    bindConFeeOrderItem,
    bindConvenienceFeeSection,
    bindConvenienceFeeSelected,
    bindDefaultDonationAmount,
    bindDonationAmountIndex,
    bindDonationAmountSelected,
    bindDonationItems,
    bindDonationOrderItems,
    bindDonationStream,
    bindFinalDonationAmount,
    bindFinalDonationAmountError,
    bindInstallmentError,
    bindInstallmentErrorMsg,
    bindIsDonationAmountEmpty,
    bindIsDonationDone,
    bindMeetFormData,
    bindMultiDonationOrderItems,
    bindMultiPayTotalTaxDeduct,
    bindNoOfPeriodicity,
    bindNoRecurringOptionAvailable,
    bindPayQuicklyData,
    bindPaymentError,
    bindPaymentOrderNo,
    bindPaymentSection,
    bindPaymentTypeMethod,
    bindPeriodicityEndDate,
    bindRecurringMethod,
    bindRecurringSection,
    bindRecurringSelection,
    bindShowHideForm,
    bindShowOneTimePayOption,
    bindTouchedFields,
    bindValidationSection
} from '../../../actions';
import { safeConferenceSendMessage } from '../../../conferenceUtils';
import ChargeDate from '../sections/ChargeDate';
import FooterSection from '../sections/FooterSection';
import RecurringSection from '../sections/RecurringSection';
import {
    fetchCampaignRaisedFresh,
    fetchConvenienceFeeCached,
    fetchPaymentDetailsCached,
    fetchRecurringDataCached,
    submitDonation
} from '../utility/apiActions';
import { XMLData as xmlData } from '../utility/jsontoxml';
import { PAGES } from '../utility/pages';
import { getStreamInfo } from '../utility/reduxDataUtils';
import {
    checkDateExpired,
    filterButtonsToShowSix,
    filterPeriodicityByEndDate,
    getButtonStyles,
    getNextStepValue,
    getRecurringKeyToValue,
    getRecurringValueToKey,
    removedecimal
} from '../utility/util';


import AlertMsg from './Alert';
import ConvenienceFee from './ConvenienceFee';
import DonationsButton from './DonationButtons';
import Installments from './Installments';
import Payment from './Payment';
import PaymentMethod from './PaymentMethod';
import Streamer from './Streamer';


const UserDonationForm = props => {
    const { t } = useTranslation();
    const [ showAmount, setShowAmount ] = useState(true);
    const [ failureMsg, setFailureMsg ] = useState(false);
    const [ payFailureMsg, setPayFailureMsg ] = useState('');
    const [ showLoader, setShowLoader ] = useState(false);
    const [ isFormDataLoading, setIsFormDataLoading ] = useState(true);
    const [ publicComments, setPublicComments ] = useState('');
    const [ isAnonymous, setIsAnonymous ] = useState(false);
    const [ isPayDone, setIsPayDone ] = useState(false);
    const [ showForm, setShowForm ] = useState(props.showDForm ?? true);
    const [ progress1, setProgress1 ] = useState(0);
    const [ totalRaised1, setTotalRaised1 ] = useState(0);
    const [ selectedChargeDate, setSelectedChargeDate ] = useState(null);
    const [ showCreditCard, setShowCreditCard ] = useState(false);
    const [ shakeError, setShakeError ] = useState(false);
    const selectDonation = (key, fallback) => state => state['features/clickandpledge']?.[key] ?? fallback;
    const confee = useSelector(selectDonation('convenienceFeeSection'));
    const formSettings = useSelector(selectDonation('formSettings', {}));
    const GUID = useSelector(selectDonation('formGUID', ''));
    const GiventID = useSelector(selectDonation('giventID', 0));
    const donationInfoData = useSelector(selectDonation('donationInfoData', []));
    const streamInfoData = useSelector(selectDonation('streamInfoData', []));
    const meetformData = useSelector(selectDonation('meetFormData', {}));
    const meetData = useSelector(selectDonation('meetData', {}));
    const recurringsArray = useSelector(selectDonation('recurringSection', {}));
    const amountsArray = useSelector(selectDonation('amountSection', {}));
    const accountMode = useSelector(selectDonation('accountMode', {}));
    const chargeDateData = useSelector(selectDonation('chargeDateData', {}));
    const campRaisedSettings = useSelector(selectDonation('campaignRaisedDetails', {}));
    const paymentArray = useSelector(selectDonation('paymentSection', []));
    const installmentErr = useSelector(selectDonation('hasInstallmentError', false));
    const recurringSelection = useSelector(selectDonation('recurringSelection', ''));
    const paymentTypeMethod = useSelector(selectDonation('paymentTypeMethod', ''));
    const recurringMethod = useSelector(selectDonation('recurringMethod', ''));
    const finalInstallmentAmt = useSelector(selectDonation('finalDonationAmt', ''));
    const defaultDonationAmount = useSelector(selectDonation('defaultDonationAmount', 0));
    const donationErr = useSelector(selectDonation('multiDonationErr', ''));
    const cnpPayQuicklyData = useSelector(selectDonation('cnpPayQuicklyData', {}));
    const otherAmountMinMaxError = useSelector(selectDonation('otherAmountMinMaxError', false));
    const noOfPeriodicity = useSelector(selectDonation('noofperiodicity', ''));
    const installments = useSelector(selectDonation('installementSelected', ''));
    const isInDefiniteRecurring = useSelector(selectDonation('isIndefiniteRecurring', false));
    const isInstallmentTouched = useSelector(selectDonation('isInstallmentTouched', false));
    const streamOptions = useSelector(selectDonation('streamOptions', {}));
    const conFeeOrderItem = useSelector(selectDonation('conFeeOrderItem', {}));
    const donationOrderItems = useSelector(selectDonation('donationOrderItems', {}));
    const multiDonOrderItems = useSelector(selectDonation('multiDonationOrderItems', []));
    const paymentError = useSelector(selectDonation('paymentErr', false));
    const noRecurringOptionAvailable = useSelector(selectDonation('noRecurringOptionAvailable', false));
    const touchedFields = useSelector(selectDonation('touchedfields', []));
    const multiPayTotalTaxDeduct = useSelector(selectDonation('multiPayTotalTaxDeduct', 0));
    const donationStream = useSelector(selectDonation('donationStream', []));
    const conference = useSelector(getCurrentConference);
    const participantsLength = useSelector(getParticipantCount);
    const { formGUID, giventToken, isEnabled } = useSelector(
        state => state['features/clickandpledge']
    );
    const reduxState = useMemo(() => {
        return {
            'features/clickandpledge': {
                donationInfoData,
                streamInfoData
            }
        };
    }, [ donationInfoData, streamInfoData ]);

    const submitStyles = useMemo(() => getButtonStyles(formSettings.SubmitButtonSettings?.FB_SubmitButton), [ formSettings ]);
    const transTotalStyles = useMemo(() => getButtonStyles(formSettings.TransactionTotalSettings?.Border_BackgroundStyle), [ formSettings ]);
    const transTotalTextStyle = formSettings.TransactionTotalSettings?.TextColor || '';
    const numberFormatter = useMemo(() => new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2
    }), []);

    const dispatch = useDispatch();
    const footerRef = useRef(null);

    // Refs to access current values in the callback without causing re-renders
    const meetformDataRef = useRef(meetformData);
    const meetDataRef = useRef(meetData);
    const accountModeRef = useRef(accountMode);
    const paymentArrayRef = useRef(paymentArray);
    const donationStreamRef = useRef(donationStream);

    meetformDataRef.current = meetformData;
    meetDataRef.current = meetData;
    accountModeRef.current = accountMode;
    paymentArrayRef.current = paymentArray;
    donationStreamRef.current = donationStream;

    const recurringValidator = useRef(new SimpleReactValidator({ messages: { required: 'Required' } }));
    const amountValidator = useRef(new SimpleReactValidator({
        messages: { required: 'Required' },
        validators: {
            other_amt_min: {
                message: 'Required',
                rule: (val, params, validator) => validator.helpers.testRegex(val, /^[0-9]{1,}$/) && params.indexOf(val) === -1
            }
        }
    }));
    const paymentValidator = useRef(new SimpleReactValidator({
        messages: {
            card_num: 'Provide valid Credit Card Number',
            required: 'Required'
        },
        validators: {
            noc_min: {
                message: 'This must be at least 2 characters.',
                rule: (val, params, validator) => validator.helpers.testRegex(val, /^.{2,}$/) && params.indexOf(val) === -1
            },
            noc_max: {
                message: 'This should not be more than 50 characters.',
                rule: (val, params, validator) => validator.helpers.testRegex(val, /^.{0,50}$/) && params.indexOf(val) === -1
            },
            ccn_min: {
                message: 'Invalid card number',
                rule: (val, params, validator) => validator.helpers.testRegex(val, /^[0-9]{15,}$/) && params.indexOf(val) === -1
            },
            ccn_max: {
                message: 'Invalid card number',
                rule: (val, params, validator) => validator.helpers.testRegex(val, /^[0-9]{1,16}$/) && params.indexOf(val) === -1
            },
            cvv_check: {
                message: t('clickandpledge.invalidCvv') || 'Invalid CVV',
                rule: (val, params, validator) => {
                    const payObj = (meetformDataRef.current?.formdata || []).find(obj => obj.payment)?.payment;
                    const cleanCcn = String(payObj?.ccn || '').replace(/\D/g, '');
                    const isAmex = /^3[47]/.test(cleanCcn);

                    if (isAmex) {
                        return validator.helpers.testRegex(val, /^[0-9]{4}$/) && params.indexOf(val) === -1;
                    }

                    return validator.helpers.testRegex(val, /^[0-9]{3,4}$/) && params.indexOf(val) === -1;
                }
            },
            zip_check: {
                message: 'Invalid ZIP',
                rule: (val, params, validator) => validator.helpers.testRegex(val, /^[a-zA-Z0-9.\-\s]{2,20}$/) && params.indexOf(val) === -1
            },
            expiry_month: {
                message: 'Please select expiry month',
                rule: (val, params, validator) => !validator.helpers.testRegex(val, /^\s*$/) && params.indexOf(val) === -1,
                required: true
            },
            expiry_year: {
                message: 'Please select expiry year',
                rule: (val, params, validator) => !validator.helpers.testRegex(val, /^\s*$/) && params.indexOf(val) === -1,
                required: true
            }
        }
    }));

    // Flags to prevent excessive API calls
    const isFormDataLoaded = useRef(false);
    const isStreamInfoLoading = useRef(false);
    const isConvenienceFeeLoading = useRef(false);
    const isDonationSubmitting = useRef(false);

    // Reset selected charge date if payment scheduling is disabled or removed from API
    useEffect(() => {
        if (!chargeDateData || !chargeDateData.AllowPaymentScheduling || Object.keys(chargeDateData).length === 0) {
            setSelectedChargeDate(null);
        }
    }, [ chargeDateData ]);

    useEffect(() => {
        const isConfeeEmpty = !confee || (Array.isArray(confee) ? confee.length === 0 : Object.keys(confee).length === 0);

        if (
            formSettings.FormSectionsToDisplay
            && formSettings.FormSectionsToDisplay.length
            && formSettings.FormSectionsToDisplay.includes('cf')
        ) {
            if (isConfeeEmpty) {
                if (isConvenienceFeeLoading.current) {
                    return;
                }

                isConvenienceFeeLoading.current = true;

                const loadConvenienceFee = async () => {
                    try {
                        const cfsec = await dispatch(fetchConvenienceFeeCached({
                            guid: GUID,
                            giventId: GiventID
                        }));

                        if (cfsec?.forms?.ConvenienceFee) {
                            dispatch(bindConvenienceFeeSection(cfsec.forms.ConvenienceFee));

                            if (cfsec.forms.ConvenienceFee.DefaultOpt === '1'
                                || cfsec.forms.ConvenienceFee.AddAdditionalFeeType === '1') {
                                dispatch(bindConvenienceFeeSelected(true));
                            }
                        }
                    } catch (err) {
                        logger.info('Convenience fee load failed', err);
                    } finally {
                        isConvenienceFeeLoading.current = false;
                    }
                };

                loadConvenienceFee();
            } else if (confee.DefaultOpt === '1' || confee.AddAdditionalFeeType === '1') {
                dispatch(bindConvenienceFeeSelected(true));
            }
        }
    }, [
        formSettings.FormSectionsToDisplay,
        confee.length,
        GiventID,
        GUID,
        dispatch
    ]);

    const filterExpiredDonations = useCallback((array = []) => array.filter(item => {
        if (item.Key === 'One Time Only') {
            return true;
        }

        return item.Value.DonationItemList.some(d => !checkDateExpired(d.StartDate, d.EndDate));
    }), []);

    const filterExpiredPeriodsByEndDate = useCallback((array = []) => array.filter(item => {
        const checkEndDate = new Date(item.Value.PeriodicityEndDate).getFullYear();

        if (item.Key === 'One Time Only' || checkEndDate === 1) {
            return true;
        }

        return filterPeriodicityByEndDate(item.Value.PeriodicityEndDate, item.Key);
    }), []);

    const filterInstallmentsAndMultiPay = useCallback((data = []) => data.filter(item =>
        item.Value.RecurringMethod === 'Subscription' && item.Value.PaymentType === 'Single Payment'
        && (item.Value.ButtonsType === 'Single Select' || item.Value.ButtonsType === null)
        && (item.Value.PreSet || item.Value.PeriodicityNoOfPeriods === 999)
    ), []);

    const showAmountComp = useCallback((recOptions = {}) => {
        const defaultRec = getRecurringKeyToValue(recOptions.DefaultFrequency);
        const defaultAmt = (recOptions.PaymentOptionsSchedulingDetails || []).filter(opt => opt.Key === defaultRec);

        if (defaultAmt?.length) {
            const defaultAmtSec = defaultAmt[0].Value;
            let updatedAmtSecArr = (defaultAmtSec.DonationItemList || []).filter(item => !checkDateExpired(item.StartDate, item.EndDate));

            updatedAmtSecArr = filterButtonsToShowSix(updatedAmtSecArr);
            if (defaultRec === 'One Time Only' && !updatedAmtSecArr.length) {
                dispatch(bindShowOneTimePayOption(true));
            }
            dispatch(bindAmountSection({
                ...defaultAmtSec,
                DonationItemList: updatedAmtSecArr
            }));
            setShowAmount(true);
        }
    }, [ dispatch ]);

    // Keep refs updated
    useEffect(() => {
        meetformDataRef.current = meetformData;
    }, [ meetformData ]);

    useEffect(() => {
        meetDataRef.current = meetData;
    }, [ meetData ]);

    useEffect(() => {
        accountModeRef.current = accountMode;
    }, [ accountMode ]);

    useEffect(() => {
        paymentArrayRef.current = paymentArray;
    }, [ paymentArray ]);

    useEffect(() => {
        donationStreamRef.current = donationStream;
    }, [ donationStream ]);

    const formSettingsRef = useRef(formSettings);

    useEffect(() => {
        formSettingsRef.current = formSettings;
    }, [ formSettings ]);

    useEffect(() => {
        isFormDataLoaded.current = false;
    }, [ GUID, GiventID ]);

    const getFormData = useCallback(async () => {
        // Prevent multiple simultaneous calls
        if (isFormDataLoaded.current) {
            return;
        }

        isFormDataLoaded.current = true;
        setIsFormDataLoading(true);

        try {
            const recurringResponse = await dispatch(fetchRecurringDataCached({
                guid: GUID,
                giventId: GiventID
            }));

            if (!recurringResponse?.forms?.Recurring) {
                return;
            }

            const recurrings = JSON.parse(JSON.stringify(recurringResponse.forms.Recurring));
            let filteredRecurring = {
                ...recurrings,
                PaymentOptionsSchedulingDetails: filterExpiredDonations(recurrings.PaymentOptionsSchedulingDetails)
            };

            filteredRecurring = {
                ...filteredRecurring,
                PaymentOptionsSchedulingDetails: filterExpiredPeriodsByEndDate(filteredRecurring.PaymentOptionsSchedulingDetails)
            };

            const seedAmount = sessionStorage.getItem('seedAmount');
            const boostStep = sessionStorage.getItem('currentBoostStep');
            const isBoostActive = Boolean(seedAmount || boostStep);
            let finalFilteredRecurring = filteredRecurring;
            const currentFormSettings = formSettingsRef.current || formSettings;
            const hasBooster = Boolean(currentFormSettings?.CampaignDetails?.EnableIntelliBooster);

            if (isBoostActive && hasBooster) {
                const boostedOptions = await getNextStepValue(
                    filteredRecurring.PaymentOptionsSchedulingDetails,
                    seedAmount
                );

                if (boostedOptions) {
                    finalFilteredRecurring = {
                        ...filteredRecurring,
                        PaymentOptionsSchedulingDetails: boostedOptions
                    };
                }
            }

            finalFilteredRecurring = {
                ...finalFilteredRecurring,
                PaymentOptionsSchedulingDetails: filterInstallmentsAndMultiPay(
                    finalFilteredRecurring.PaymentOptionsSchedulingDetails
                )
            };

            const keyExists = finalFilteredRecurring.PaymentOptionsSchedulingDetails.some(
                obj => obj.Key === getRecurringKeyToValue(recurrings.DefaultFrequency)
            );

            if (!keyExists && finalFilteredRecurring.PaymentOptionsSchedulingDetails.length) {
                finalFilteredRecurring.DefaultFrequency = getRecurringValueToKey(
                    finalFilteredRecurring.PaymentOptionsSchedulingDetails[0].Key
                );
            }
            if (!finalFilteredRecurring.PaymentOptionsSchedulingDetails.length) {
                dispatch(bindNoRecurringOptionAvailable(true));
            }

            if (finalFilteredRecurring.DefaultFrequency && finalFilteredRecurring.PaymentOptionsSchedulingDetails.length) {
                const recItems = finalFilteredRecurring.PaymentOptionsSchedulingDetails.filter(
                    opt => opt.Key === getRecurringKeyToValue(finalFilteredRecurring.DefaultFrequency)
                );
                const recMethod = recItems?.[0]?.Value;

                if (recMethod && Object.keys(recMethod).length) {
                    dispatch(bindDonationItems(recMethod.DonationItemList));

                    // Use RecurringMethod as paymentTypeMethod for recurring payments, fallback to PaymentType
                    const paymentType = recMethod.RecurringMethod || recMethod.PaymentType;

                    dispatch(bindPaymentTypeMethod(paymentType));
                    dispatch(bindRecurringMethod(recMethod.RecurringMethod));
                    dispatch(bindNoOfPeriodicity(recMethod.PeriodicityNoOfPeriods));
                    dispatch(bindPeriodicityEndDate(recMethod.PeriodicityEndDate));
                    dispatch(bindRecurringSelection(
                        getRecurringKeyToValue(finalFilteredRecurring.DefaultFrequency)
                    ));

                    const boostedItem = isBoostActive && hasBooster
                        ? (recMethod.DonationItemList || []).find(item => item.DefaultSelection)
                        : null;

                    if (boostedItem && boostedItem.DefaultValue !== undefined) {
                        dispatch(bindDonationAmountSelected(boostedItem.DefaultValue));
                        dispatch(bindDonationAmountIndex(boostedItem.ItemID));
                        dispatch(bindFinalDonationAmount(boostedItem.DefaultValue));
                        dispatch(bindDefaultDonationAmount(boostedItem.DefaultValue));
                        dispatch(bindIsDonationAmountEmpty(false));

                        const updatedFormData = meetformDataRef.current?.formdata
                            ? meetformDataRef.current.formdata.map(q => {
                                return {
                                    ...q,
                                    amountsection: boostedItem.DefaultValue,
                                    other_amount: ''
                                };
                            })
                            : [ {
                                amountsection: boostedItem.DefaultValue,
                                other_amount: ''
                            } ];

                        dispatch(bindMeetFormData({ formdata: updatedFormData }));
                    }
                }
            }

            dispatch(bindRecurringSection(finalFilteredRecurring));
            showAmountComp(finalFilteredRecurring);
            dispatch(bindIsDonationDone(false));
            setIsPayDone(false);

            if (!paymentArrayRef.current.length) {
                const paysec = await dispatch(fetchPaymentDetailsCached({
                    guid: GUID,
                    giventId: GiventID
                }));

                if (paysec?.forms?.PaymentDetails) {
                    dispatch(bindPaymentSection(paysec.forms.PaymentDetails));
                    dispatch(bindPayQuicklyData(paysec));

                    // Only initialize form data if it doesn't exist or is empty
                    const currentFormData = meetformDataRef.current;
                    const currentMeetData = meetDataRef.current;
                    const currentAccountMode = accountModeRef.current;

                    const shouldInitializeForm = !currentFormData.formdata
                        || currentFormData.formdata.length === 0
                        || !currentFormData.formdata[0]?.payment;

                    if (shouldInitializeForm) {
                        const defaultRec = getRecurringKeyToValue(recurrings.DefaultFrequency);
                        const paymentData = currentMeetData.display_name
                            ? {
                                first_name: currentMeetData.first_name || '',
                                last_name: currentMeetData.last_name || '',
                                noc: currentMeetData.display_name || '',
                                ccn: currentAccountMode.Mode === 'Y' ? 4111111111111111 : '',
                                expiryMonth: currentAccountMode.Mode === 'Y' ? 12 : '',
                                expiryYear: currentAccountMode.Mode === 'Y'
                                    ? (new Date().getFullYear() % 100) + 1 : '',
                                cvv: currentAccountMode.Mode === 'Y' ? '123' : '',
                                zipcode: currentAccountMode.Mode === 'Y' ? '24060' : '',
                                email: currentMeetData.email || ''
                            }
                            : {
                                first_name: '',
                                last_name: '',
                                noc: '',
                                ccn: '',
                                expiryMonth: '',
                                expiryYear: '',
                                cvv: '',
                                zipcode: '',
                                email: ''
                            };

                        dispatch(bindMeetFormData({
                            formdata: [ {
                                recurrings: defaultRec || '',
                                payment: paymentData
                            } ]
                        }));
                    }
                }
            }
        } catch (err) {
            logger.error('getFormData error', err);
            isFormDataLoaded.current = false;
        } finally {
            setIsFormDataLoading(false);
        }
    }, [ GUID, GiventID, dispatch, fetchPaymentDetailsCached, fetchRecurringDataCached,
        filterExpiredDonations, filterExpiredPeriodsByEndDate, filterInstallmentsAndMultiPay,
        formSettings, showAmountComp ]);

    const getStreamsInfo = useCallback(async () => {
        if (!props.meetingData || !props.userData || isStreamInfoLoading.current) {
            return;
        }

        isStreamInfoLoading.current = true;

        try {
            const res = await getStreamInfo(reduxState, props.meetingData.meetingId);
            const streamData = res.data?.body?.donations || [];

            if (!streamData.length) {
                return;
            }

            streamData.map(s => {
                return {
                    firstName: s.firstName || '',
                    lastName: s.lastName || '',
                    amount: parseFloat(s.amount || 0).toFixed(2),
                    comments: s.comments || '',
                    dDate: s.dDate || new Date().toISOString()
                        .split(' ')[0],
                    periodicity: s.periodicity || '',
                    orderNumber: s.orderNumber || '',
                    transitionId: s.transitionId || undefined,
                    notified: false
                };
            });

            const existing = donationStreamRef.current || [];

            const newStreams = streamData.filter(newItem =>
                !existing.some(oldItem => oldItem.orderNumber === newItem.orderNumber)
            );

            if (newStreams.length) {
                const updatedStreamData = [ ...existing, ...newStreams ];

                dispatch(bindDonationStream(updatedStreamData));
            }

        } catch (err) {
            logger.info(err);
        } finally {
            isStreamInfoLoading.current = false;
        }
    }, [ props.meetingData, props.userData, reduxState, dispatch ]);

    const getCampaignRaisedData = useCallback(async () => {
        const settings = formSettingsRef.current;

        // Try multiple sources for CampaignID
        const campaignID = settings.CampaignDetails?.CampaignID
            || settings.campaignID
            || settings.CampaignID;

        if (campaignID) {
            try {
                const campResponse = await fetchCampaignRaisedFresh({
                    organizationId: settings.OrganizationID,
                    campaignId: campaignID
                })();

                if (campResponse) {
                    dispatch(bindCampaignRaisedDetails(campResponse));
                }
            } catch (err) {
                logger.error('getCampaignRaisedData error', err);
            }
        }
    }, [ dispatch ]);


    useEffect(() => {
        safeConferenceSendMessage(conference, {
            type: FORMGUID,
            streamOptions,
            GiventID,
            clickandPledge: isEnabled,
            formGuid: formGUID
        }, 'clickandpledge-givent:UserDonationForm:broadcastFormGuid');
    }, [ conference, giventToken, isEnabled, formGUID, participantsLength, streamOptions, GiventID ]);

    useEffect(() => {
        getCampaignRaisedData();
        getStreamsInfo();
    }, [ donationStream, GUID, GiventID, giventToken, isEnabled, formGUID ]);


    useEffect(() => {
        if (failureMsg) {
            const timeoutId = setTimeout(() => {
                setFailureMsg(false);
                setPayFailureMsg('');
            }, 8000);

            return () => clearTimeout(timeoutId);
        }
    }, [ failureMsg ]);

    useEffect(() => {
        const totalRaised = campRaisedSettings?.CampaignRaised || 0;

        setTotalRaised1(parseFloat(removedecimal(totalRaised)));
        const goalAmt = campRaisedSettings?.CampaignTarget || 0;
        const progrs = goalAmt > 0 ? (removedecimal(totalRaised) / removedecimal(goalAmt)) * 100 : 0;

        setProgress1(progrs);
    }, [ donationStream, campRaisedSettings ]);

    useEffect(() => {
        if (GUID && GiventID && !isFormDataLoaded.current) {
            getFormData();
        }
    }, [ GUID, GiventID, getFormData ]);

    useEffect(() => {
        if (typeof props.showDForm === 'boolean') {
            setShowForm(props.showDForm);
            if (props.showDForm) {
                setIsPayDone(false);
                dispatch(bindIsDonationDone(false));
            }
        }
    }, [ props.showDForm, dispatch ]);

    const showStream = useCallback(() => {
        setShowForm(false);
        dispatch(bindShowHideForm(false));
        setIsPayDone(false);
        dispatch(bindIsDonationDone(false));
        if (sessionStorage.getItem('skipToPayment')) {
            sessionStorage.removeItem('skipToPayment');
        }
        isFormDataLoaded.current = false;
    }, [ dispatch ]);

    const handleDonate = useCallback(async () => {
        if (isDonationSubmitting.current) {
            return false;
        }
        let hasError = false;
        const userinfo = meetformData.formdata?.find(obj => obj.payment);

        if (!userinfo || !userinfo.payment) {
            logger.error('Payment info not found in form data');
            setFailureMsg(true);
            setPayFailureMsg(t('clickandpledge.paymentInfoMissing'));
            setIsPayDone(false);
            window.scrollTo(0, 0);

            return false;
        }

        if (!recurringValidator.current.allValid()) {
            recurringValidator.current.showMessages();
            hasError = true;
        }

        // Check finalInstallmentAmt - ensure it's a valid positive number
        // For Multiple Payment, finalInstallmentAmt should already be calculated from multi-donation items
        const parsedAmount = parseFloat(finalInstallmentAmt);

        if (isNaN(parsedAmount) || parsedAmount <= 0) {
            dispatch(bindIsDonationAmountEmpty(true));
            hasError = true;
            const amountWrapper = document.querySelector('.amount_btns_wrapper');

            if (amountWrapper) {
                amountWrapper.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
        if (!amountValidator.current.allValid() && paymentTypeMethod !== 'Multiple Payment') {
            amountValidator.current.showMessages();
            hasError = true;
            const amountWrapper = document.querySelector('.amount_btns_wrapper');

            if (amountWrapper) {
                amountWrapper.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }

        const cleanCcn = String(userinfo?.payment?.ccn || '').replace(/\D/g, '');
        const isAmexCard = /^3[47]/.test(cleanCcn);
        const minCvvLen = isAmexCard ? 4 : 3;
        const isCvvLengthInvalid = Boolean(userinfo?.payment?.cvv && userinfo.payment.cvv.length < minCvvLen);

        const userEmail = userinfo?.payment?.email || meetData.email;
        const isPaymentInvalid = !paymentValidator.current.allValid() || paymentError
            || !userinfo?.payment?.first_name || !userinfo?.payment?.last_name || !userinfo?.payment?.noc
            || !userinfo?.payment?.ccn || !userinfo?.payment?.expiryMonth || !userinfo?.payment?.expiryYear
            || !userinfo?.payment?.cvv || isCvvLengthInvalid || !userinfo?.payment?.zipcode || !userEmail;

        let currentTouched = [ ...touchedFields ];

        if (isPaymentInvalid) {
            dispatch(bindValidationSection({
                AmountSection: false,
                PaymentSection: true
            }));
            const ffields = Object.fromEntries(
                Object.entries(userinfo?.payment || {}).filter(([ , v ]) => v === '')
            );
            let tfields = Object.keys(ffields);

            if (!userEmail) {
                tfields = [ ...tfields, 'email' ];
            }
            const allPayFields = [ 'email', 'first_name', 'last_name', 'noc', 'ccn', 'expiryMonth',
                'expiryYear', 'cvv', 'zipcode' ];
            let filtered = allPayFields.filter(
                value => !Object.keys(userinfo?.payment || {}).includes(value)
            );

            if (tfields.length) {
                filtered = [ ...filtered, ...tfields ];
            }
            currentTouched = Array.from(new Set([ ...currentTouched, ...filtered ]));
            if (!userinfo?.payment?.expiryMonth || !userinfo?.payment?.expiryYear) {
                dispatch(bindPaymentError(true));
            }
            paymentValidator.current.showMessages();

            hasError = true;
        }

        if (userinfo?.payment?.zipcode?.length < 2) {
            paymentValidator.current.showMessages();
            currentTouched = Array.from(new Set([ ...currentTouched, 'zipcode' ]));
            hasError = true;
        }

        if (!userinfo?.payment?.cvv || isCvvLengthInvalid) {
            paymentValidator.current.showMessages();
            currentTouched = Array.from(new Set([ ...currentTouched, 'cvv' ]));
            dispatch(bindValidationSection({
                AmountSection: false,
                PaymentSection: true
            }));
            dispatch(bindPaymentError(true));
            hasError = true;
        }

        dispatch(bindTouchedFields(currentTouched));

        if (noOfPeriodicity === -1 && recurringMethod === 'Subscription') {
            const install = isInDefiniteRecurring ? 999 : installments;

            if (!install) {
                dispatch(bindInstallmentErrorMsg(t('clickandpledge.enterInstallmentPeriods')));
                dispatch(bindInstallmentError(true));
                hasError = true;
            }
        }
        if (!isInDefiniteRecurring && !installments && recurringMethod === 'Subscription' && recurringSelection && recurringSelection !== 'One Time Only') {
            dispatch(bindInstallmentErrorMsg(t('clickandpledge.enterPeriods')));
            dispatch(bindInstallmentError(true));
            hasError = true;
        }
        if (finalInstallmentAmt && !installments && recurringMethod && recurringMethod !== 'Subscription') {
            dispatch(bindInstallmentErrorMsg(t('clickandpledge.enterInstallmentPeriods')));
            dispatch(bindInstallmentError(true));
            hasError = true;
        }
        if (finalInstallmentAmt && finalInstallmentAmt < 1) {
            dispatch(bindFinalDonationAmountError(true));
            hasError = true;
        }
        if (otherAmountMinMaxError || installmentErr || donationErr
            || sessionStorage.getItem('multiError') === 'true') {
            hasError = true;
        }
        if (hasError) {
            let errorMsg = '';

            if (otherAmountMinMaxError) {
                errorMsg = t('clickandpledge.enterValidAmount');
            } else if (finalInstallmentAmt && finalInstallmentAmt < 1) {
                errorMsg = t('clickandpledge.amountCannotBeLessThan', { currency: formSettings.Currency });
            } else if (isNaN(parsedAmount) || parsedAmount <= 0) {
                errorMsg = t('clickandpledge.enterValidAmount');
            } else if (isPaymentInvalid) {
                errorMsg = t('clickandpledge.enterValidCardDetails');
            } else if (installmentErr) {
                errorMsg = t('clickandpledge.enterInstallmentPeriods');
            } else if (donationErr) {
                errorMsg = donationErr;
            }

            errorMsg = errorMsg || t('clickandpledge.fixErrorsToProceed') || 'Please fill in all required fields correctly.';
            setFailureMsg(true);
            setPayFailureMsg(errorMsg);
            dispatch(showNotification({
                appearance: 'error',
                description: errorMsg,
                titleKey: 'clickandpledge.PaymentFailedDescriptionTitle'
            }, NOTIFICATION_TIMEOUT));

            setIsPayDone(false);
            setShakeError(true);
            setTimeout(() => setShakeError(false), 700);
            window.scrollTo(0, 0);

            return false;
        }

        isDonationSubmitting.current = true;
        setShowLoader(true);
        dispatch(bindValidationSection({
            AmountSection: false,
            PaymentSection: false
        }));
        dispatch(bindIsDonationAmountEmpty(false));
        dispatch(bindPaymentError(false));
        sessionStorage.setItem('multiError', false);

        const uname = userinfo.payment.noc;
        const udata = {
            display_name: uname,
            first_name: userinfo.payment.first_name,
            last_name: userinfo.payment.last_name,
            email: userinfo.payment.email || meetData.email
        };
        const donationAmount = finalInstallmentAmt || 0;

        const accountInfo = {
            accountId: formSettings.OrganizationID,
            accountGuid: formSettings.AccountGUID,
            GiventID: formSettings.GiventID
        };
        const matchingGifts = {
            companyID: formSettings.DDCompanyID,
            companyName: formSettings.DDCompanyName
        };
        const peerToPeer = {
            teamURL: formSettings.TeamURLAlias,
            fundraiserEmail: formSettings.FundraiserEmail
        };
        const installmentsVal = isInDefiniteRecurring ? 999 : installments;
        const conFeeOrder = Object.keys(conFeeOrderItem).length ? conFeeOrderItem : '';
        let donationItems = Object.keys(donationOrderItems).length ? donationOrderItems : '';
        let multiDonationItems = multiDonOrderItems.length ? multiDonOrderItems : [];
        let multiTotalTaxDeduct = multiPayTotalTaxDeduct > 0 ? multiPayTotalTaxDeduct : 0;

        if (recurringMethod !== 'Subscription' && !isInDefiniteRecurring && installments
            && multiDonationItems.length) {
            multiDonationItems = multiDonationItems.map(obj => {
                return {
                    ...obj,
                    dItemPrice: parseFloat(removedecimal(obj.dItemPrice / installments)),
                    taxDeductible: parseFloat(removedecimal(parseFloat(obj.taxDeductible / installments)))
                };
            });
            multiTotalTaxDeduct = parseFloat(
                removedecimal(multiDonationItems.reduce((total, el) => total + el.taxDeductible, 0))
            );
        }

        if (Object.keys(donationItems).length) {
            const mergedFormData = Array.isArray(meetformData.formdata)
                ? meetformData.formdata.reduce((acc, curr) => Object.assign(acc, curr), {})
                : meetformData.formdata || {};
            const amountSec = mergedFormData.amountsection ?? meetformData.formdata?.[0]?.amountsection;
            const otherAmt = mergedFormData.other_amount ?? meetformData.formdata?.[0]?.other_amount;

            let originalAmount = parseFloat(amountSec) === -1
                ? parseFloat(otherAmt).toFixed(2)
                : amountSec;

            originalAmount = isNaN(originalAmount) && recurringMethod !== 'Subscription' ? donationAmount
                : isNaN(originalAmount) && recurringMethod === 'Subscription' ? defaultDonationAmount
                    : originalAmount;
            let newDonItems = { ...donationItems };

            if (!donationItems.taxDeductible || isNaN(donationItems.taxDeductible)) {
                const taxPct = parseFloat(newDonItems.taxPercentage) || 0;

                newDonItems.taxDeductible = parseFloat(
                    removedecimal((parseFloat(originalAmount || 0) * taxPct) / 100)
                ) || 0;
            }
            const defaultItem = amountsArray.DonationItemList?.filter(arr => arr.DefaultSelection);

            if (!originalAmount && isNaN(newDonItems.taxDeductible) && defaultDonationAmount > 0
                && (!donationItems.taxDeductible || isNaN(donationItems.taxDeductible))) {
                if (defaultItem && defaultItem.length > 0) {
                    newDonItems = {
                        dItemName: defaultItem[0].ItemName,
                        dsku: defaultItem[0].SKU,
                        dgau: defaultItem[0].GAU,
                        taxDeductible: parseFloat(removedecimal(
                            (defaultItem[0].DefaultValue * (defaultItem[0].TaxDeductible || 0)) / 100
                        )) || 0
                    };
                }
            }
            if (isNaN(newDonItems.taxDeductible) || newDonItems.taxDeductible === undefined) {
                newDonItems.taxDeductible = 0;
            }
            donationItems = newDonItems;
        }

        // Properly extract campaignID with fallback logic (matching getCampaignRaisedData)
        const campaignID = formSettings.CampaignDetails?.CampaignID
            || formSettings.campaignID
            || formSettings.CampaignID;

        const campaignData = {
            campaignName: formSettings.CampaignDetails?.CampaignName,
            campaignID,
            payWidgetID: formSettings.CampaignDetails?.PaymentWidgetID,
            socialCommentsStatus: formSettings.PaymentOptionSettings?.LiveStream
        };

        const IPAddress = formSettings.IPAddress;
        const Version = '20251229.002.001.037';
        const Tracker = formSettings.Tracker;
        const ReciptTaxDeductable = formSettings.TaxDeductible;

        let chargeDate = '';

        if (selectedChargeDate) {
            const ndate = new Date(selectedChargeDate);
            const today = new Date();

            today.setHours(0, 0, 0, 0);

            if (ndate > today) {
                const yy = String(ndate.getFullYear()).slice(-2);
                const mm = String(ndate.getMonth() + 1).padStart(2, '0');
                const dd = String(ndate.getDate()).padStart(2, '0');

                chargeDate = `${yy}/${mm}/${dd}`;
            }
        }
        let xmldata;

        try {
            xmldata = xmlData({
                data: meetformData.formdata,
                amount: donationAmount,
                recSelection: recurringSelection,
                installments: installmentsVal,
                userinfo: udata,
                account: accountInfo,
                matchingGifts,
                peerToPeer,
                comments: publicComments || '',
                conFeeOrder,
                recMethod: recurringMethod,
                campaignData,
                singlePayItems: donationItems,
                MultiPayItems: multiDonationItems,
                multiPayTotalTaxDeduct: multiTotalTaxDeduct,
                defaultDonationAmount,
                isAnonymous,
                isInstallmentTouched,
                IsInDefiniteRecurring: isInDefiniteRecurring,
                Tracker,
                IPAddress,
                Version,
                ReciptTaxdeductable: ReciptTaxDeductable,
                chargeDate
            });
        } catch (xmlError) {
            logger.error('XMLData generation error:', xmlError);
            setFailureMsg(true);
            setPayFailureMsg(t('clickandpledge.errorPreparingPayment'));
            setShowLoader(false);
            setIsPayDone(false);
            isDonationSubmitting.current = false;

            return false;
        }
        try {
            const result = await dispatch(submitDonation({ xmldata }));

            if (result?.resultCode === '0') {
                const newStreamData = {
                    firstName: isAnonymous ? 'Anonymous' : udata.first_name,
                    lastName: isAnonymous ? '' : udata.last_name,
                    amount: donationAmount.toString(),
                    comments: publicComments || ' ',
                    orderNumber: result.orderNumber,
                    periodicity: recurringSelection,
                    transitionId: result.gatewayTransactionNumber,
                    notified: false
                };

                // Append new donation to existing stream data from Redux instead of replacing
                const updatedStreamData = [ ...donationStream, newStreamData ];

                dispatch(bindDonationStream(updatedStreamData));

                // Refresh campaign raised data to update the goal meter
                await getCampaignRaisedData();

                const isBroadcastSent = safeConferenceSendMessage(conference, {
                    type: DONATION_MAREQUE,
                    streamData: newStreamData
                }, 'clickandpledge-givent:UserDonationForm:donationMarquee');

                if (!isBroadcastSent) {
                    dispatch(showNotification({
                        titleKey: 'connection.DISCONNECTED',
                        descriptionKey: 'clickandpledge.broadcastSkippedDisconnected'
                    }, NOTIFICATION_TIMEOUT));
                }
                if (props.meetingData && props.userData) {

                    try {
                        setShowLoader(false);
                        setPublicComments('');
                        dispatch(bindPaymentOrderNo(result.orderNumber));
                        dispatch(bindValidationSection({
                            AmountSection: false,
                            PaymentSection: false
                        }));
                        dispatch(bindMultiDonationOrderItems([]));
                        dispatch(bindMultiPayTotalTaxDeduct(0));
                        dispatch(bindDonationOrderItems({}));
                        dispatch(bindConFeeOrderItem({}));
                        const defaultFeeSelected = confee?.DefaultOpt === '1' || confee?.AddAdditionalFeeType === '1';

                        dispatch(bindConvenienceFeeSelected(defaultFeeSelected));
                    } catch (saveErr) {
                        logger.error('Error resetting form state after successful donation:', saveErr);
                    }

                    // Navigation must happen regardless of state reset errors
                    dispatch(bindIsDonationDone(true));
                    setIsPayDone(true);
                    setShowForm(false);
                    setShowLoader(false);

                    props.onNavigate(PAGES.SUCCESS, {
                        udata,
                        totalAmount: donationAmount,
                        showStream
                    });
                } else {
                    setShowLoader(false);
                    dispatch(bindPaymentOrderNo(result.orderNumber));
                    dispatch(bindIsDonationDone(true));
                    setIsPayDone(true);
                    setShowForm(false);

                    if (props.onNavigate) {
                        props.onNavigate(PAGES.SUCCESS, {
                            udata,
                            totalAmount: donationAmount,
                            showStream
                        });
                    }
                }
            } else {
                const errorMsg = result?.resultData || t('clickandpledge.errorPreparingPayment');

                setFailureMsg(true);
                setPayFailureMsg(errorMsg);
                setShowLoader(false);
                setIsPayDone(false);
                dispatch(showNotification({
                    appearance: 'error',
                    description: errorMsg,
                    titleKey: 'clickandpledge.PaymentFailedDescriptionTitle'
                }, NOTIFICATION_TIMEOUT));
            }
        } catch (err) {
            if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
                return false;
            }
            logger.error('donation submit error', err);
            const errorMsg = t('clickandpledge.errorPreparingPayment');

            setFailureMsg(true);
            setPayFailureMsg(errorMsg);
            setShowLoader(false);
            setIsPayDone(false);
            dispatch(showNotification({
                appearance: 'error',
                description: errorMsg,
                titleKey: 'clickandpledge.PaymentFailedDescriptionTitle'
            }, NOTIFICATION_TIMEOUT));
        } finally {
            isDonationSubmitting.current = false;
        }


    }, [ meetformData, finalInstallmentAmt, paymentTypeMethod, paymentError, meetData, dispatch,
        noOfPeriodicity, recurringMethod, recurringSelection, installments, isInDefiniteRecurring,
        otherAmountMinMaxError, installmentErr, donationErr, formSettings, conFeeOrderItem,
        donationOrderItems, multiDonOrderItems, multiPayTotalTaxDeduct, defaultDonationAmount,
        isInstallmentTouched, props, selectedChargeDate, touchedFields, amountsArray,
        recurringsArray, isAnonymous, publicComments, donationStream, conference, t ]);

    const saveComments = useCallback(() => {
        if (publicComments) {
            dispatch(bindMeetFormData({
                formdata: meetformData.formdata ? meetformData.formdata.map(q => {
                    return {
                        ...q,
                        publicComments
                    };
                }) : [ { publicComments } ]
            }));
        }
    }, [ publicComments, dispatch, meetformData ]);
    const onAnonymousChange = useCallback(() => setIsAnonymous(s => !s), []);
    const onPaymentDone = useCallback(() => setIsPayDone(false), []);

    const handlePaymentMethodSubmit = useCallback(() => {
        // Handle payment method submission
    });

    const showDonationForm = useCallback(() => {
        dispatch(bindShowHideForm(true));
        setShowForm(true);
        setIsPayDone(false);
        dispatch(bindIsDonationDone(false));

        const isBoost = Boolean(
            sessionStorage.getItem('boostClicked') === 'true'
            || sessionStorage.getItem('seedAmount')
            || sessionStorage.getItem('currentBoostStep')
        );

        if (!isFormDataLoaded.current) {
            getFormData();
        }

        // Check if we should skip to payment section for already registered users
        if (sessionStorage.getItem('skipToPayment')) {
            sessionStorage.removeItem('skipToPayment');

            if (!isBoost) {
                // Set some default values to bypass amount/recurring selection
                // This will help the form validation pass and focus on payment
                dispatch(bindDonationAmountSelected(defaultDonationAmount || 25)); // Set a default amount
                dispatch(bindRecurringSelection('onetime')); // Set default to one-time payment
                dispatch(bindRecurringMethod('onetime'));
                dispatch(bindPaymentTypeMethod('onetime'));
            }

            // Set validation to focus on payment section
            setTimeout(() => {
                const paymentSection = document.querySelector('.payment-section');

                if (paymentSection) {
                    paymentSection.scrollIntoView({ behavior: 'smooth' });
                }
            }, 500);
        }

        window.scrollTo(0, 0);
        dispatch(bindMeetFormData({
            formdata: meetformData.formdata ? meetformData.formdata.map(q => {
                return {
                    ...q,
                    payment: {
                        ...q.payment,
                        ccn: accountMode.Mode === 'Y' ? 4111111111111111 : '',
                        expiryMonth: accountMode.Mode === 'Y' ? 12 : '',
                        expiryYear: accountMode.Mode === 'Y' ? (new Date().getFullYear() % 100) + 1 : '',
                        cvv: accountMode.Mode === 'Y' ? '123' : '',
                        zipcode: accountMode.Mode === 'Y' ? '24060' : ''
                    }
                };
            }) : [ {
                payment: {
                    ccn: '',
                    cvv: '',
                    expiryMonth: '',
                    expiryYear: '',
                    zipcode: ''
                }
            } ]
        }));
    }, [ dispatch, meetformData, accountMode, defaultDonationAmount, getFormData ]);

    const boostUpDonation = useCallback(amt => {
        const cleanAmt = amt ? parseFloat(String(amt).replace(/[^0-9.]/g, '')) : null;

        if (cleanAmt) {
            sessionStorage.setItem('seedAmount', String(cleanAmt));
        }
        sessionStorage.setItem('boostClicked', 'true');
        setIsPayDone(false);
        dispatch(bindIsDonationDone(false));
        dispatch(bindShowHideForm(true));
        setShowForm(true);
        isFormDataLoaded.current = false;
        getFormData();
    }, [ dispatch, getFormData ]);


    if (isFormDataLoading) {
        return (
            <div className = 'loader-container'>
                <div className = 'lds-ellipsis'>
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        );
    }

    const shouldHideDonationForm = (!showForm && donationStream.length && !giventToken && !props.skipAuthentication)
        || (!props.showDForm && donationStream.length === 0)
        || noRecurringOptionAvailable;
    const donationFormWrapperStyle = {
        display: shouldHideDonationForm ? 'none' : 'block'
    };
    const progressSectionStyle = { margin: '0.5rem 0' };
    const rawPct1 = isNaN(progress1) ? 0 : parseFloat(progress1);
    const fillWidth1 = Math.min(100, Math.max(0, rawPct1));
    const progressText1 = rawPct1 > 100 ? '100% +' : `${Math.round(rawPct1)}%`;
    const progressBarStyle = {
        width: `${fillWidth1}%`
    };
    const raisedLoadingStyle = {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '1rem'
    };
    const raisedLoadingTextStyle = {
        fontSize: '12px',
        paddingLeft: '1rem'
    };
    const anonymousCheckboxStyle = { verticalAlign: 'middle' };
    const transTotalWrapperStyle = transTotalStyles ? {
        '--LIcolor': transTotalTextStyle,
        '--LIbgColor': transTotalStyles['background-color'],
        '--LIborderColor': transTotalStyles['border-color']
    } : null;
    const transTotalContentStyle = {
        fontSize: '11px',
        fontWeight: 'bold',
        width: '100%',
        padding: '4px'
    };
    const chargeAmountStyle = { float: 'right' };
    const submitWrapperStyle = submitStyles ? {
        '--borderColor': submitStyles['border-color'],
        '--color': submitStyles.color,
        '--bgColor': submitStyles['background-color'],
        '--fontWeight': submitStyles['font-weight'],
        '--bRadius': submitStyles['border-radius'],
        '--bhRadius': `${formSettings.SubmitButtonSettings?.SubmitBtnMousehoverBorderRadius}px`
    } : null;

    return (
        <>
            {noRecurringOptionAvailable && <AlertMsg
                isClose = { true }
                message = { t('clickandpledge.noValidPaymentOptions') }
                subMessage = { t('clickandpledge.contactAdministrator') }
                type = 'failure' />}

            {donationStream.length > 0 && !showForm && !noRecurringOptionAvailable
                && Object.keys(streamOptions).length > 0 && streamOptions.SPS === 1
                ? <Streamer
                    boostUpDonation = { boostUpDonation }
                    currency = { formSettings.Currency }
                    data = { donationStream }
                    fRef = { footerRef }
                    handleShowForm = { showDonationForm }
                    hideHeader = { true }
                    meetingData = { props.meetingData }
                    showForm = { showForm }
                    userData = { props.userData } />
                : <div
                    className = 'donation_form_wrapper'
                    style = { donationFormWrapperStyle }>
                    <div className = 'outlet'>
                        <div className = 'form_input_wrapper'>
                            <div
                                className = 'progress_section_wrapper'
                                style = { progressSectionStyle }>
                                {Object.keys(streamOptions).length > 0 && streamOptions.SPM === 1
                                    && streamOptions.SPS === 0 && (
                                    <>
                                        {campRaisedSettings.CampaignTarget > 0 ? (
                                            <>
                                                <div className = 'progress_info_wrapper'>
                                                    <div className = 'raised'>
                                                        {formSettings.Currency}
                                                        {campRaisedSettings.CampaignRaised > 0
                                                            ? numberFormatter.format(totalRaised1)
                                                            : '0.00'}
                                                    </div>
                                                    <div className = 'goal'>
                                                        {t('clickandpledge.goal')} {formSettings.Currency
                                                                + numberFormatter.format(removedecimal(campRaisedSettings.CampaignTarget))
                                                                    .replace(/\.00$/, '')}
                                                    </div>
                                                </div>
                                                <div
                                                    className = 'progress-bar-container'
                                                    data-progress = { fillWidth1 }>
                                                    <div
                                                        className = 'progress-bar'
                                                        style = { progressBarStyle } />
                                                    <span className = 'progress-text'>{progressText1}</span>
                                                </div>
                                            </>
                                        ) : (
                                            <div className = 'progress_info_wrapper'>
                                                {campRaisedSettings.CampaignRaised > 0
                                                    ? <div className = 'raised'>
                                                        {t('clickandpledge.totalRaised')} {formSettings.Currency}
                                                        {numberFormatter.format(totalRaised1)}
                                                    </div>
                                                    : <div
                                                        style = { raisedLoadingStyle }>
                                                        {/* <ThreeDots
                                                        height = '40px'
                                                        width = '50px' /> */}
                                                        <span
                                                            style = { raisedLoadingTextStyle }>
                                                            {t('clickandpledge.loading')}
                                                        </span>
                                                    </div>}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                        {!isPayDone && (
                            <>
                                <div className = 'recurring_amount_info_wrapper'>
                                    {formSettings?.FormSectionsToDisplay?.includes('rec')
                                        && <RecurringSection recurringValidator = { recurringValidator } />}
                                    {showAmount && formSettings?.FormSectionsToDisplay?.includes('amt') && (
                                        <>
                                            <DonationsButton
                                                amountValidator = { amountValidator }
                                                callbackOnPaymentDone = { onPaymentDone }
                                                isDonePayment = { isPayDone }
                                                showhideForm = { showForm } />
                                            {noOfPeriodicity <= 998 && recurringSelection
                                                && recurringSelection !== 'One Time Only'
                                                && Object.keys(amountsArray).length > 0
                                                && amountsArray.PreSet && <Installments />}
                                        </>
                                    )}
                                    {cnpPayQuicklyData?.forms?.Active && formSettings.FormSectionsToDisplay?.includes('cf') && <ConvenienceFee />}
                                </div>
                                {Object.keys(chargeDateData).length > 0
                                    && chargeDateData.AllowPaymentScheduling
                                    && <ChargeDate
                                        chargeDate = { chargeDateData }
                                        onDateChange = { setSelectedChargeDate }
                                        title = { formSettings.SectionTitlesHeadersSettings?.ChargeDatetitle } />
                                }
                                {cnpPayQuicklyData?.forms?.Active && <PaymentMethod
                                    getCampaignRaisedData = { getCampaignRaisedData }
                                    onNavigate = { props.onNavigate }
                                    onSubmit = { handlePaymentMethodSubmit }
                                    requireContactInfo = { props.requireContactInfo }
                                    selectedChargeDate = { selectedChargeDate }
                                    setShowCreditCard = { setShowCreditCard }
                                    showCreditCard = { showCreditCard } />}
                                {(!cnpPayQuicklyData?.forms?.Active || showCreditCard) && <div id = 'credit-card-payment-section'>
                                    <Payment
                                        isDonePayment = { isPayDone }
                                        paymentValidator = { paymentValidator } />

                                    <div className = 'anonymous_wrapper'>
                                        {!cnpPayQuicklyData?.forms?.Active && formSettings.FormSectionsToDisplay?.includes('cf') && <ConvenienceFee />}
                                        {formSettings.PaymentOptionSettings?.ShowAnonymous === 'Show' && (
                                            <div className = 'form_input_wrapper display_anonymous'>
                                                <input
                                                    className = 'display_anonymous_input'
                                                    id = 'display_anonymous_input'
                                                    onChange = { onAnonymousChange }
                                                    style = { anonymousCheckboxStyle }
                                                    type = 'checkbox' />
                                                <label htmlFor = 'display_anonymous_input'>
                                                    {formSettings?.BillingInfoSettings?.BillingInfo_Makethisdonationanonymous
                                                        || t('clickandpledge.displayAsAnonymous')}
                                                </label>
                                            </div>
                                        )}
                                        {formSettings.PaymentOptionSettings
                                            && (formSettings.PaymentOptionSettings.LiveStream === 1
                                                || formSettings.PaymentOptionSettings.LiveStream === 2) && (
                                            <div className = 'form_input_wrapper'>
                                                <label htmlFor = 'comments'>
                                                    {formSettings?.BillingInfoSettings?.BillingInfo_PublicPosted
                                                            || t('clickandpledge.comments')}
                                                </label>
                                                <textarea
                                                    className = 'comments'
                                                    id = 'comments'
                                                    maxLength = { 140 }
                                                    onBlur = { saveComments }
                                                    onChange = { e => setPublicComments(e.target.value) }
                                                    value = { publicComments } />
                                            </div>
                                        )}
                                    </div>

                                    {failureMsg && <AlertMsg
                                        isClose = { true }
                                        message = { parse(payFailureMsg) }
                                        subMessage = ''
                                        type = 'failure' />}

                                    {formSettings.TransactionTotalSettings?.FormBottomShow !== 'hide' && (
                                        <div
                                            className = 'form_input_wrapper d-flex justify-content-between'
                                            style = { transTotalWrapperStyle }>
                                            <div
                                                className = { transTotalStyles ? 'transTotalStyle' : '' }
                                                style = { transTotalContentStyle }>
                                                {formSettings.SectionTitlesHeadersSettings?.ChargedTitle && (
                                                    <>
                                                        {selectedChargeDate
                                                            && formSettings.SectionTitlesHeadersSettings.ChargedTitle
                                                            === t('clickandpledge.youWillBeCharged')
                                                            ? t('clickandpledge.onDateYouWillBeCharged', {
                                                                date: new Date(selectedChargeDate).toLocaleDateString('en-US', {
                                                                    month: 'long',
                                                                    day: 'numeric',
                                                                    year: 'numeric'
                                                                })
                                                            })
                                                            : /{ChargeDate}/i.test(
                                                                formSettings.SectionTitlesHeadersSettings.ChargedTitle
                                                            )
                                                                ? formSettings.SectionTitlesHeadersSettings.ChargedTitle.replace(
                                                                    /{ChargeDate}/gi,
                                                                    new Date(selectedChargeDate || new Date()).toLocaleDateString('en-US', {
                                                                        month: 'long',
                                                                        day: 'numeric',
                                                                        year: 'numeric'
                                                                    })
                                                                )
                                                                : parse(formSettings.SectionTitlesHeadersSettings.ChargedTitle)}
                                                        <span style = { chargeAmountStyle }>
                                                            {formSettings.Currency}
                                                            {finalInstallmentAmt && finalInstallmentAmt !== -1
                                                                ? numberFormatter.format(finalInstallmentAmt)
                                                                + (recurringSelection && recurringSelection !== 'One Time Only'
                                                                    ? `/${recurringSelection}` : '')
                                                                : '0.00'}
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div
                                        className = 'form_input_wrapper d-flex justify-content-between'
                                        style = { submitWrapperStyle }>
                                        <button
                                            className = { `${submitStyles ? 'submitButtonSettings' : ''} full_button tabindex_btn next${shakeError ? ' shake-donate-btn' : ''}` }
                                            disabled = { showLoader }
                                            onClick = { handleDonate }
                                            type = 'button'>
                                            {showLoader
                                                ? <div className = 'sppinner-givent'>
                                                    <span
                                                        aria-hidden = 'true'
                                                        className = { 'loading-spinner sm primary' }
                                                        role = 'status'>
                                                        <span className = 'spinner-border' />
                                                    </span>
                                                    <span>{t('clickandpledge.processing')}</span>
                                                </div>
                                                : t('clickandpledge.pay', {
                                                    currency: formSettings.Currency,
                                                    amount: finalInstallmentAmt && finalInstallmentAmt !== -1
                                                        ? numberFormatter.format(finalInstallmentAmt)
                                                        : '0.00'
                                                })}
                                        </button>
                                    </div>
                                </div>}
                                {donationStream.length > 0 && Object.keys(streamOptions).length > 0
                                    && streamOptions.SPS === 1
                                    && <div className = 'back_btn_wrapper'>
                                        <button
                                            onClick = { showStream }
                                            type = 'button'>
                                            &#60; {t('clickandpledge.viewStream')}
                                        </button>
                                    </div>
                                }
                                <FooterSection />
                            </>
                        )}
                    </div>
                </div>
            }


        </>
    );
};

export default UserDonationForm;
